import React, { useState, useEffect } from "react";
import Table from "../../../core/pagination/datatable";
import { Card, Alert } from "antd";
import PreselectedListsPanel from "./PreselectedListsPanel";
import {
  ChevronUp,
  Edit,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import ListDetailsView from "../listdetailsview";
import { listsTableColumns } from "./CreateCampaign/listsTableColumns";
import FormLayout from "./CreateCampaign/FormLayout";
import SegmentSelectionBlock from "./SegmentSelectionBlock";

const ListsBlock = ({
  onListCreated,
  listOptions,
  rankedListOptions,
  selectedList,
  setSelectedList,
  segmentOptions,
  selectedSegment,
  setSelectedSegment,
  priority,
  setPriority,
  testContOptions,
  selectTestCont,
  setSelectTestCont,
  maxAllOptions,
  selectMaxAll,
  setSelectMaxAll,
  comment,
  setComment,
  shipQty,
  setShipQty,
  mailQty,
  setMailQty,
  performance,
  setPerformance,
  cost,
  setCost,
  sourceCode,
  setSourceCode,
  productCategory,
  setProductCategory,
  handleSaveList,
  transformedLists,
  totalQtyNeeded,
  AlllistOptions,
  segmentAllOptions,
  onSegmentsUpdated,
  campaigns = [],
}) => {
  const [totalQtySelected, setTotalQtySelected] = useState(0);
  const [qtyMessage, setQtyMessage] = useState(null);
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const [selectedListId, setSelectedListId] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [isListDrawerOpen, setIsListDrawerOpen] = useState(false);
  const [editListId, setEditListId] = useState(null);
  // When selecting from SegmentSelectionBlock, we may need to wait for segment options to refresh
  const [pendingSegmentName, setPendingSegmentName] = useState(null);
console.log("campaigns 4", campaigns, transformedLists)
  useEffect(() => {
    if (transformedLists && transformedLists.length > 0) {
      const total = transformedLists.reduce((sum, list) => {
        return sum + (parseInt(list.orderQty) || 0);
      }, 0);
      setTotalQtySelected(total);

      if (total < totalQtyNeeded) {
        setQtyMessage({
          type: "warning",
          message: `Selected quantity (${total}) is less than needed quantity (${totalQtyNeeded})`,
        });
      } else if (total > totalQtyNeeded) {
        setQtyMessage({
          type: "info",
          message: `Selected quantity (${total}) exceeds needed quantity (${totalQtyNeeded})`,
        });
      } else {
        setQtyMessage(null);
      }
    } else {
      setTotalQtySelected(0);
      setQtyMessage({
        type: "warning",
        message: `No quantity selected. Needed quantity: ${totalQtyNeeded}`,
      });
    }
  }, [transformedLists, totalQtyNeeded]);
  const handleAddToTransformedLists = (listData) => {
    if (typeof handleSaveList === "function") {
      const cleanedData = {
        ...listData,
        productCategory:
          typeof listData.productCategory === "object"
            ? listData.productCategory.label
            : listData.productCategory,
      };
      handleSaveList(cleanedData);
    }
  };

  useEffect(() => {
    if (!selectedList || !campaigns?.length) return;

    const listId = selectedList?.value || selectedList?.id;

    const matched = campaigns.find((c) => c.id === listId);

    if (matched?.brand) {
      setSelectedBrand(matched.brand);
    } else {
      setSelectedBrand(null);
    }
  }, [campaigns, selectedList]);

  const handleAddPreselectedList = (item) => {
    const listData = {
      list_id: item.listOption.value,
      list_name: item.listOption.label,
      segment_id: item.segmentOption ? item.segmentOption.value : "",
      segment_name: item.segmentOption ? item.segmentOption.label : "",
      priority: item.priority,
      selectTestCont: item.testCont.label,
      orderQty: item.orderQty,
      selectMaxAll: item.maxAll.label,
      comment: item.comment,
      source_code: item.source_code,
      productCategory: item.productCategory,
      performance: item.performance || "-",
      cost: item.cost || 0,
      period: item.period || "-",
      quantity: item.quantity || 0,
      category: item.category || "-",
      date_released: item.date_released || "-",
    };
    console.log("list data when select from top", listData);
    handleAddToTransformedLists(listData);
  };

  const setListAndSegment = ({ list_name, segment_name, mailed_quantity }) => {
    const listOption = AlllistOptions.find((o) => o.label === list_name) || null;
    // 1) Set the list immediately
    setSelectedList(listOption);
    // 1b) Also set Ship Qty from the segment's mailed quantity
    if (typeof mailed_quantity !== "undefined" && mailed_quantity !== null) {
      setShipQty(mailed_quantity);
    }
    // 2) Defer setting the segment until the segment options refresh for the selected list
    setPendingSegmentName(segment_name || null);
  };

  // Once segment options update for the newly-selected list, set the matching segment
  useEffect(() => {
    if (!pendingSegmentName) return;
    if (!Array.isArray(segmentAllOptions) || segmentAllOptions.length === 0) return;

    const match = segmentAllOptions.find((o) => o.label === pendingSegmentName);
    if (match) {
      setSelectedSegment(match);
      setPendingSegmentName(null);
    }
  }, [segmentAllOptions, pendingSegmentName, setSelectedSegment]);

  return (
    <>
      <Card size="small" style={{ minWidth: 0, overflow: "hidden" }}>
        {qtyMessage && (
          <Alert
            message={qtyMessage.message}
            type={qtyMessage.type}
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        <PreselectedListsPanel
          selectedBrand={selectedBrand}
          listOptions={listOptions}
          rankedListOptions={rankedListOptions}
          fullLists={campaigns}
          testContOptions={testContOptions}
          maxAllOptions={maxAllOptions}
          onAddToMainList={handleAddPreselectedList}
          lists={campaigns}
          productCategory={productCategory}
          setProductCategory={productCategory}
        />
        
        {/* Add the new SegmentSelectionBlock component */}
        <SegmentSelectionBlock
          segmentAllOptions={segmentAllOptions}
          selectedSegment={selectedSegment}
          setSelectedSegment={setSelectedSegment}
          selectedList={selectedList}
          setSelectedList={setSelectedList}
          AlllistOptions={AlllistOptions}
          setListAndSegment={setListAndSegment}
          campaigns={campaigns}
        />
        
        <FormLayout
          sourceCode={sourceCode}
          setSourceCode={setSourceCode}
          AlllistOptions={AlllistOptions}
          selectedList={selectedList}
          setSelectedList={setSelectedList}
          segmentAllOptions={segmentAllOptions}
          selectedSegment={selectedSegment}
          setSelectedSegment={setSelectedSegment}
          priority={priority}
          setPriority={setPriority}
          testContOptions={testContOptions}
          selectTestCont={selectTestCont}
          setSelectTestCont={setSelectTestCont}
          shipQty={shipQty}
          setShipQty={setShipQty}
          mailQty={mailQty}
          setMailQty={setMailQty}
          maxAllOptions={maxAllOptions}
          selectMaxAll={selectMaxAll}
          setSelectMaxAll={setSelectMaxAll}
          comment={comment}
          setComment={setComment}
          productCategory={productCategory}
          cost={cost}
          setCost={setCost}
          handleSaveList={handleSaveList}
          campaigns={campaigns}
          setIsListDrawerOpen={setIsListDrawerOpen}
          setEditListId={setEditListId}
        />
        {transformedLists.length > 0 && (
          <Table
            bordered
            size="small"
            className="table-sm small-font table-responsive mt-3"
            pagination={false}
            columns={listsTableColumns}
            dataSource={transformedLists}
          />
        )}
      </Card>

      {/* add list component */}
      <ListDetailsView
        isVisible={isListDrawerOpen}
        onClose={() => setIsListDrawerOpen(false)}
        onResize={() => {
          console.log("Resizing sidebar to");
        }}
        clientId={null}
        listId={editListId}
        onListCreated={onListCreated}
        onSegmentsUpdated={onSegmentsUpdated} 
      />
    </>
  );
};

export default ListsBlock;
